export const contactFormUrl = "https://bt.sg/feedback";
export const newspostUrl = "https://newspost.newslink.sg/";

export const sphText = "Copyright SPH Media. All rights reserved.";
export const nonSphText =
  "Share with us your feedback on BT's products and services";
